import { render, staticRenderFns } from "./NotationOld.vue?vue&type=template&id=0ca18b42&"
import script from "./NotationOld.vue?vue&type=script&lang=js&"
export * from "./NotationOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports